import React from 'react'
import { Button, CloseButton, OverlayTrigger, Popover } from 'react-bootstrap'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './FormFieldPopover.module.scss'

const FormFieldPopover = ({
  id,
  placement,
  text,
  btnClassname,
  noPopoverHeader = false,
  ...other
}) => (
  <OverlayTrigger
    trigger="click"
    placement={placement}
    overlay={
      <Popover id={id} className={styles.formFieldPopover}>
        {!noPopoverHeader && (
          <div className="popover-header">
            <CloseButton onClick={() => document.body.click()} />
          </div>
        )}
        <div
          className={classNames('popover-body', { [styles.bodyNoPopoverHeader]: noPopoverHeader })}
        >
          {text}
        </div>
      </Popover>
    }
    rootClose
    {...other}
  >
    <Button variant="default" className={classNames(styles.formFieldInfo, btnClassname)}>
      ?
    </Button>
  </OverlayTrigger>
)

FormFieldPopover.defaultProps = {
  placement: 'top-start'
}

FormFieldPopover.propTypes = {
  id: PropTypes.string.isRequired,
  placement: PropTypes.oneOf([
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
  ]),
  text: PropTypes.node.isRequired
}

export default FormFieldPopover
